import React from "react";
import { baseUrl } from "../../libs/env";
import { size } from "lodash";
import {
  AccountType,
  assessmentFlow,
} from "../../components/constants/constants";
import { Exitbtn } from "../../components/buttons/exitbtn";
import B2CNextButton from "../../components/buttons/B2C_Next";
import B2CPreviousButton from "../../components/buttons/B2C_Previous";
import B2CSubmitButton from "../../components/buttons/B2C_SubmitButton";

export const B2CAssessmentButtons = ({
  currentSection,
  setCurrentSection,
  currentSectionPage,
  IsonRecorder,
  setCurrentSectionPage,
  pagesOfCurrentSection,
  total_sections,
  data,
  isSubmitting,
  isReview,
  isAiGradingexercise,
  GWarningToggle,
  AisubmissionCounter,
  setAisubmissionCounter,
  sectionCounter,
  setsectionCounter,
}) => {
  let showNextButton = true;
  let currentNextSection = currentSection;
  let currentNextSectionPage = currentSectionPage;
  if (isReview && data.sections) {
    total_sections = data.sections[0].section_number;
  }
  if (
    pagesOfCurrentSection === currentNextSectionPage &&
    currentSection !== total_sections
  ) {
    currentNextSection = currentNextSection + 1;
    currentNextSectionPage = 0;
  }

  if (
    currentNextSection === total_sections &&
    pagesOfCurrentSection === currentNextSectionPage
  ) {
    showNextButton = false;
  }

  let backButtonCurrentSection = currentSection;
  let backButtonCurrentPage = currentSectionPage;
  if (isReview || backButtonCurrentSection !== 1) {
    if (currentSectionPage === 1) backButtonCurrentSection -= 1;
    else backButtonCurrentPage -= 1;
    data &&
      data.sessions &&
      data.sessions.forEach((session) => {
        if (session.section_number === backButtonCurrentPage) {
          backButtonCurrentPage = session.total_pages;
        }
      });
    // backButtonCurrentPage = 6;
  }
  const handleNextclick = () => {
    setCurrentSection(currentNextSection);
    setCurrentSectionPage(
      parseInt(
        `${currentNextSection}${currentNextSectionPage + 1}`
      )
    );
    if(isAiGradingexercise && data?.is_premium && AisubmissionCounter > 0){
      setAisubmissionCounter(parseInt(
        `${AisubmissionCounter - 1}`
      ))
      setsectionCounter(prevState => {
        const newCount = (prevState[`${currentNextSection}`] || 0) + 1;
        return { ...prevState, [`${currentNextSection}`]: newCount };
      });
    }
  }
  const handlePrevclick = () => {
    setCurrentSection(backButtonCurrentSection);
    setCurrentSectionPage(
      parseInt(
        `${backButtonCurrentSection}${backButtonCurrentPage}`
      )
    );
    if(AisubmissionCounter < data?.remaining_credits)
    {      
      setAisubmissionCounter(prevCounter => {
        const increment = sectionCounter[`${backButtonCurrentSection}`] || 0;
        return Math.max(prevCounter + increment, 0);
      });
      setsectionCounter(prevState => {
        return { ...prevState, [`${backButtonCurrentSection}`]: 0 };
      });
    }
  }
  return (
    <div
      className={
        currentSectionPage === 1
          ? "row d-flex justify-content-end mt-2"
          : "row d-flex justify-content-end mt-2"
      }
    >
      {/* <div className="col-lg-4 col-md-4 col-sm-4 col-4 b2c-smps-5 py-2">
        {data.user_type === AccountType.STAFF && data.assessment_flow !== assessmentFlow.SEQUENTIAL ? (
          // eslint-disable-next-line no-script-url
          <Exitbtn class="py-2 btn-lg fw-600 rounded-5" href="javascript:window.open('','_self').close();" />
        ) : isReview && (showNextButton || currentSectionPage !== 1) ? (
          <Exitbtn class="py-2 btn-lg fw-600 rounded-5"
            href={
              localStorage.getItem("reportUrl")
                ? `${localStorage.getItem("reportUrl")}`
                : `${baseUrl}/user/test-performance/${data?.student_assessment_id}`
            }
          />
        ) : null}
      </div> */}

      <div
        className={
          currentSectionPage === 1 && isReview
            ? "text-end col-lg-8 col-md-8 col-sm-8 col-8 pe-0 py-2 d-flex justify-content-end"
            : "text-end col-lg-8 col-md-8 col-sm-8 col-8 pe-0 py-2 d-flex justify-content-end"
        }
      >
        {isReview || data.user_type === AccountType.STAFF ? (
          <div className="col-12 d-flex justify-content-end">
            {(currentSectionPage === 1 && isReview ) ||((!isReview && currentSectionPage === 1 && total_sections === 1 )) ? null : (
              <div className="d-inline">
                <B2CPreviousButton
                  IsonRecorder={IsonRecorder}
                  label={"Previous"}
                  onClick={() => {
                    setCurrentSection(backButtonCurrentSection);
                    setCurrentSectionPage(
                      parseInt(
                        `${backButtonCurrentSection}${backButtonCurrentPage}`
                      )
                    );
                  }}
                />
              </div>
            )}
            {showNextButton ? (
              <div className="ps-3">
              <B2CNextButton
                IsonRecorder={IsonRecorder}
                onClick={() => {
                  setCurrentSection(currentNextSection);
                  setCurrentSectionPage(
                    parseInt(
                      `${currentNextSection}${currentNextSectionPage + 1}`
                    )
                  );
                }}
              />
              </div>
            ) : (currentSectionPage === 1 && data.user_type !== AccountType.STAFF) && (
              <div>
              {/* <Exitbtn
                href={
                  localStorage.getItem("reportUrl")
                    ? `${localStorage.getItem("reportUrl")}`
                    : `${baseUrl}/user/test-performance/${data?.student_assessment_id}`
                }
              /> */}
              </div>
            )}
          </div>
        ) : (
          <div className="d-flex justify-content-end">
            {(currentSection === 1 && currentSectionPage === 1) ||
            data.assessment_flow ===
              assessmentFlow.SEQUENTIAL_EARLY_STOP ? null : (
              <div className="me-3 d-inline">
                <B2CPreviousButton
                  IsonRecorder={IsonRecorder}
                  label={"Previous"}
                  onClick={handlePrevclick}
                />
              </div>
            )}
            {/* {isAiGradingexercise && (data?.is_anonymous_user || (data?.is_premium && AisubmissionCounter <= 0))  ? (
              <B2CSubmitButton
              IsonRecorder={IsonRecorder}
              isSubmitting={isSubmitting}
              onClick={() => {
                GWarningToggle()
              }}
              btnContent={
                (data.assessment_flow ===
                  assessmentFlow.SEQUENTIAL_EARLY_STOP &&
                size(data.sections_pages) > 1) ||
                (showNextButton && data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP) ? (
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.05304 9.46409H17.909M17.909 9.46409L9.981 1.53613M17.909 9.46409L9.981 17.3921"
                      stroke="white"
                      stroke-width="2.26513"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  "Submit"
                )
              }
            />) : */}
            {showNextButton && data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP ? (
              <B2CNextButton
                IsonRecorder={IsonRecorder}
                onClick={handleNextclick}
              />
            ) : data.user_type === AccountType.STUDENT ? (
              <B2CSubmitButton
                IsonRecorder={IsonRecorder}
                isSubmitting={isSubmitting}
                btnContent={
                  data.assessment_flow ===
                    assessmentFlow.SEQUENTIAL_EARLY_STOP &&
                  size(data.sections_pages) > 1 ? (
                    <svg
                      width="20"
                      height="19"
                      viewBox="0 0 20 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.05304 9.46409H17.909M17.909 9.46409L9.981 1.53613M17.909 9.46409L9.981 17.3921"
                        stroke="white"
                        stroke-width="2.26513"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  ) : (
                    "Submit"
                  )
                }
              />
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};
